// @core/api/endpoints/document/archive_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ArchiveDocumentRequest,
  DocumentLifecycleResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Archive document
 * Archives a document-aware entity, removing it from active use but retaining it for records.
 */
export async function ArchiveDocument(
  target_type: string,
  target_id: string,
  data: ArchiveDocumentRequest,
  options?: RequestOptions
): Promise<DocumentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/archive`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<DocumentLifecycleResponse>(requestPath, data, requestOptions);
}
